// extracted by mini-css-extract-plugin
export default {"frame":"ChatBar_frame__Ne9o5","chat-container":"ChatBar_chat-container__VOqjG","message-window":"ChatBar_message-window__+U2Pl"};